import {
    ValgStateActionTypes,
    TOGGLE_UTBETALINGSPLAN,
    ToogleUtbetalingsplanAction,
    TOGGLE_VILKAR,
    ToogleFordelingAction,
    ToogleVilkarAction,
    TOGGLE_FORDELING,
    UPDATE_VALG,
} from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederVgsUtenUrAppState } from '..';
import { AnyAction } from 'redux';
import { maksSkolepenger, finnMaksArstimer, fulltidArstimer } from '../../Veileder';
import { fSkolepengerValidering, dArstimerValidering, dProsentValidering } from '../../Utilities/ValideringParameters';
import { validerMinMax } from '../../../Shared/Scripts/Utilities/Validering';
import { setVisning, updateValidation } from '../Resultat/Actions';
import C from '../../Utilities/C-FulltidDeltidValg';
import D from '../../Utilities/D-ArstimerProsent';
import E from '../../Utilities/E-SkolepengerValg';
import { ValideringsResultat } from '../../../Shared/Scripts/Models/ValideringsResultat';
import { ValgState } from '../../../VeilederOmgjoringBasisLan/Store/Valg/Types';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleUtbetalingsplan(): ToogleUtbetalingsplanAction {
    return {
        type: TOGGLE_UTBETALINGSPLAN,
    };
}

export function toggleVilkar(): ToogleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

export function toggleFordeling(): ToogleFordelingAction {
    return {
        type: TOGGLE_FORDELING,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederVgsUtenUrAppState, {}, AnyAction> => {
    return (
        dispatch: ThunkDispatch<VeilederVgsUtenUrAppState, {}, AnyAction>,
        getState: () => VeilederVgsUtenUrAppState,
    ): void => {
        const currentState = getState();
        const visBoksB = visB(currentState);
        const visBoksC = visC(currentState, visBoksB);
        const visBoksD = visD(currentState, visBoksC);
        const dValidation = isDvalid(currentState, visBoksD);
        const visBoksE = visE(currentState, visBoksC, visBoksD, dValidation);
        const visBoksF = visF(currentState, visBoksE);
        const fValidation = isFValid(currentState, visBoksF);
        const visResultat = visRes(currentState, visBoksE, visBoksF, fValidation);
        const visDelvisResultat = visResGx(currentState, visBoksD);
        const visFordeling = visResFordeling(currentState, visResultat, visDelvisResultat);
        dispatch(updateValidation({ dValidation }));
        dispatch(updateValidation({ fValidation }));
        dispatch(
            setVisning({
                visBoksB,
                visBoksC,
                visBoksD,
                visBoksE,
                visBoksF,
                visFordeling,
                visResultat,
                visDelvisResultat,
            }),
        );
    };
};

const visB = (state: VeilederVgsUtenUrAppState): boolean => {
    return state.valg.aStudieretning !== undefined;
};

const visC = (state: VeilederVgsUtenUrAppState, visBoksB: boolean): boolean => {
    return visBoksB && state.valg.bVarighet !== undefined;
};

const visD = (state: VeilederVgsUtenUrAppState, visBoksC: boolean): boolean => {
    return visBoksC && state.valg.cFulltidDeltid?.value === C.c2_deltid;
};

const visE = (state: VeilederVgsUtenUrAppState, visBoksC: boolean, visBoksD: boolean, dValidation?: ValideringsResultat): boolean => {
    return (
        (visBoksC && state.valg.cFulltidDeltid?.value === C.c1_fulltid) ||
        (visBoksD && dValidation?.isValid === true && state.valg.dArstimerProsent?.vetIkke === false)
    );
};

const visF = (state: VeilederVgsUtenUrAppState, visBoksE: boolean): boolean => {
    return visBoksE && state.valg.eSkolepenger?.value === E.e1_ja;
};

const visRes = (
    state: VeilederVgsUtenUrAppState,
    visBoksE: boolean,
    visBoksF: boolean,
    fValidation: ValideringsResultat | undefined,
): boolean => {
    return (
        (visBoksE && state.valg.eSkolepenger?.value === E.e2_nei) ||
        (visBoksF && state.valg.fSpBelop !== undefined && isValid(fValidation))
    );
};

const visResGx = (state: VeilederVgsUtenUrAppState, visBoksD: boolean): boolean => {
    return visBoksD && state.valg.dArstimerProsent?.vetIkke === true;
};

const visResFordeling = (state: VeilederVgsUtenUrAppState, visResultat: boolean, visResultatGx: boolean): boolean => {
    return (visResultat || visResultatGx) && state.valg.hBosted !== undefined;
};

const isFValid = (state: VeilederVgsUtenUrAppState, visBoksF: boolean): ValideringsResultat | undefined => {
    if (visBoksF && state.valg.fSpBelop !== undefined && state.satser != null) {
        const maxSkolepenger = maksSkolepenger(state.valg, state.satser);
        const valideringParameters = fSkolepengerValidering(maxSkolepenger, state.epiContext.locale);
        const validering = validerMinMax(state.epiContext, state.valg.fSpBelop, valideringParameters);
        return validering;
    }
    return undefined;
};

const isDvalid = (state: VeilederVgsUtenUrAppState, visBoksD: boolean): ValideringsResultat | undefined => {
    if (visBoksD && state.valg.dArstimerProsent?.verdi !== undefined) {
        if (state.valg.dArstimerProsent.type === D.d1_arstimer) {
            const fulltid = fulltidArstimer(state.valg);
            const maksArstimer = finnMaksArstimer(state.valg, fulltid);
            const valideringParameters = dArstimerValidering(maksArstimer);
            return validerMinMax(state.epiContext, state.valg.dArstimerProsent.verdi, valideringParameters);
        } else {
            return validerMinMax(state.epiContext, state.valg.dArstimerProsent.verdi, dProsentValidering);
        }
    }
    return undefined;
};

const isValid = (resultat: ValideringsResultat | undefined): boolean => {
    return resultat?.isValid === true;
};
